import Vue from 'vue';
import App from './App.vue';
import router from './router';
import storage from '@/model/storage.js';
import ViewUI from 'view-design';
import VDistpicker from 'v-distpicker';
import vData from '@/pages/order/views/vData';
import vDataMulti from '@/pages/order/views/vDataMulti';
import vDataAfter from '@/pages/order/views/vDataAfter';
import afficheSidebar from '@/components/afficheSidebar/afficheSidebar';
import 'view-design/dist/styles/iview.css';
import smartParse from 'vue-smart-parse';
import Antd from 'ant-design-vue'//引入组件
import locale from 'ant-design-vue/lib/locale-provider/zh_CN';
import 'ant-design-vue/dist/antd.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.prototype.STORAGE = storage;
Vue.use(ViewUI);
Vue.use(Antd)
Vue.use(ElementUI)
Vue.use(smartParse);
Vue.component('v-distpicker', VDistpicker);
Vue.component('o-vData', vData);
Vue.component('o-vDataMulti', vDataMulti);
Vue.component('o-vDataAfter', vDataAfter);
Vue.component('v-afficheSidebar', afficheSidebar);

Vue.config.productionTip = false

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js